import { getConfigAsync } from '../../../environmentConfig';
import { getLastLoginTry, setLastLoginTry } from '../../stores/globalState';

import { LoginRequest } from './types';

const LOGIN_TRY_BUFFER = 500;

export const getJsNames = async (): Promise<string> => {
  const { STUDENT_GIT_SHA } = await getConfigAsync();

  return `student-${STUDENT_GIT_SHA}.js problem-${STUDENT_GIT_SHA}.js`;
};

export const markLastLoginTry = (): void => {
  const now = new Date().getTime();
  const lastLoginTry = getLastLoginTry();

  if (lastLoginTry && lastLoginTry > now - LOGIN_TRY_BUFFER) {
    return;
  }

  setLastLoginTry(now);
};

export const getParamsFromUrl = async (
  args: LoginRequest
): Promise<LoginRequest> => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('classId')) {
    const classId = urlParams.get('classId') || undefined;

    args.classId = classId;
  }

  return {
    ...args,
    username: args.username || '',
    password: args.password || '',
    jsFiles: await getJsNames(),
  };
};
